import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Credits from './Credits.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      meta: {
        permissions: ['administrator', 'billing_manage'],
        superAdminOrPermission: true,
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        icon: 'credit-card-person',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'billing_manage'],
            superAdminOrPermission: true,
          },
        },
        {
          path: 'credits',
          name: 'billing_credits_index',
          component: Credits,
          meta: {
            permissions: ['administrator'],
            superAdminOrPermission: true,
          },
        },
      ],
    },
  ],
};
